<template>
  <svg
    class="wf-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
    v-html="body"
  />
</template>

<script>
/**
 * One Workflow redesign icon (24x24 stroke grid, stroke = currentColor). `name` is a key of WF_ICONS
 * (./wfIcons.js: constant SVG bodies from the design export, never user data). An unknown name draws an
 * empty box of the same size, so a row never shifts.
 */
import { WF_ICONS } from './wfIcons';

export default {
  name: 'WfIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 16 },
    stroke: { type: [Number, String], default: 1.9 },
  },
  computed: {
    body() {
      return Object.prototype.hasOwnProperty.call(WF_ICONS, this.name) ? WF_ICONS[this.name] : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.wf-icon {
  display: block;
  flex: none;
}
</style>
